import {
	Component,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
} from '@angular/core';
import { PopoverController } from '@ionic/angular';
import format from 'date-fns/format';
import isAfter from 'date-fns/isAfter';
import isWithinInterval from 'date-fns/isWithinInterval';
import subDays from 'date-fns/subDays';
import subMinutes from 'date-fns/subMinutes';

import { LearningService } from 'src/app/pages/app/learning/service/learning.service';
import { RudderStack } from 'src/app/services';
import { RatingModalComponent } from './rating-modal/rating-modal.component';

@Component({
	selector: 'app-cards',
	templateUrl: './cards.component.html',
	styleUrls: ['./cards.component.scss'],
})
export class CardsComponent implements OnInit, OnChanges {
	@Input() data: any;

	@Input() type: 'class' | 'events' | 'assignments' | 'announcement' = 'class';

	isLock = false;
	unLockStr: string = '';
	expandSubStr = '';
	optionCard = false;
	status: 'Locked' | 'Unlocked' | 'In progress' | 'Completed';
	colorClass = 'background-Greens-Light_Green_2';
	icon: string;
	iconToast: string;
	announcementType = 'cal';
	toolTipText: string;
	isCurrent: boolean;
	rate: any;
	isOverDue: boolean;
	arrowIconName = 'chevron-down-outline';
	constructor(
		private popoverController: PopoverController,
		private learningService: LearningService,
		private rudderStack: RudderStack
		) {}

	ngOnChanges(changes: SimpleChanges) {
		const data = changes.data.currentValue;
		const type = changes.type.currentValue;

		if (type === 'class' || type === 'assignments') {
			this.isLock = isAfter(new Date(data.startDateTime), new Date());
		} else if (type === 'events') {
			this.isLock = isAfter(
				subDays(new Date(data.startDateTime), 1),
				new Date(),
			);
		}

		if (this.isLock) {
			this.unLockStr =
				'Unlocks on ' + format(new Date(data.startDateTime), 'dd MMM');

			this.status = 'Locked';
			if (type === 'class') {
				this.expandSubStr =
					'Unlocks on ' +
					format(new Date(data.startDateTime), 'dd MMM yyyy • hh:mm a');
			} else if (type === 'assignments') {
				this.expandSubStr =
					'Unlocks on ' +
					format(new Date(data.startDateTime), 'dd MMM yyyy • hh:mm a');
			} else if (type === 'events') {
				this.unLockStr =
					'Live on ' + format(new Date(data.startDateTime), 'dd MMM');
				this.expandSubStr =
					'Live on ' +
					format(new Date(data.startDateTime), 'dd MMM yyyy • hh:mm a');
			}
		} else {
			if (type === 'class') {
				if (!data.rate) {
					let avg = 0;
					this.rate = 0;
					const modulesLength = data.modules?.filter(obj => obj.mandatory)
						?.length;
					let isInProgress = data.modules.filter(
						obj => obj.rate > 0 && obj.rate < 100,
					);
					// const completedArray = data.modules.filter(obj => obj.rate === 100);
					// if (completedArray.length !== data.modules.length) {
					// 	isInProgress.push({ rate: 1 });
					// }
					let rate = 0;
					if (modulesLength > 0) {
						rate = data.modules
							?.filter(obj => obj.mandatory)
							.reduce((acc, obj) => {
								return acc + obj.rate;
							}, 0);

						avg = Math.floor(
							rate / data.modules?.filter(obj => obj.mandatory)?.length,
						);
						if (avg !== 100 && avg === 0) {
							let optionalList = data.modules?.filter(obj => !obj.mandatory);
							optionalList = optionalList.find(obj => obj.rate === 100);
							if (optionalList) {
								avg = 10;
							}
						}

						if (avg !== 100 && isInProgress.length > 0) {
							avg = isInProgress[0].rate;
						}
					} else {
						data.modules.map(obj => {
							rate = rate + obj?.rate ? obj.rate : 0;
						});
						avg = Math.floor(rate / data.modules?.length);
					}
					data['rate'] = avg;

					if (avg === 0 || isNaN(avg)) {
						data['rate'] = 0;
					}
				}

				if (data.rate === 0) {
					this.status = 'Unlocked';
					this.expandSubStr =
						'Unlocked on ' +
						format(new Date(data.startDateTime), 'dd MMM yyyy • hh:mm a');
					this.unLockStr = 'Unlocked';
				} else if (data.rate < 100) {
					this.status = 'In progress';
					this.expandSubStr =
						'Unlocked on ' +
						format(new Date(data.startDateTime), 'dd MMM yyyy • hh:mm a');
					this.unLockStr = 'Unlocked';
				} else if (data.rate === 100) {
					this.status = 'Completed';
					this.unLockStr = 'Rate this class';
					this.expandSubStr =
						'Unlocked on ' +
						format(new Date(data.startDateTime), 'dd MMM yyyy • hh:mm a');
				}
			} else if (type === 'events') {
				this.expandSubStr =
					format(new Date(data.startDateTime), 'dd MMM yyyy • hh:mm a') +
					' - ' +
					format(new Date(data.endDateTime), 'hh:mm a');

				const isFuture = isAfter(new Date(), new Date(data.endDateTime));
				this.unLockStr = `Live on ${format(
					new Date(data.startDateTime),
					'dd MMMM',
				)}`;
				const isOver = isAfter(new Date(), new Date(data.endDateTime));
				this.isCurrent = isWithinInterval(new Date(), {
					start: subMinutes(new Date(this.data.startDateTime), 15),
					end: new Date(this.data.endDateTime),
				});

				if ((data.attended || data.viewed) && isFuture) {
					this.status = 'Completed';
					this.unLockStr = 'Rate this event';
				} else {
					const MeetBefore15Min = isWithinInterval(new Date(), {
						start: subMinutes(new Date(data.startDateTime), 15),
						end: new Date(data.endDateTime),
					});

					if (MeetBefore15Min) {
						this.status = 'In progress';
					} else {
						this.status = 'Unlocked';
					}
					if (isOver) {
						this.unLockStr = 'Event over';
						this.expandSubStr =
							'Concluded on ' +
							format(new Date(data.startDateTime), 'dd MMM yyyy • hh:mm a') +
							' - ' +
							format(new Date(data.endDateTime), 'hh:mm a');
					}
				}
			} else if (type === 'assignments') {
				this.isOverDue = isAfter(new Date(), new Date(data.endDateTime));

				this.status = data.assignmentStatus;
				this.icon = 'pencil-outline';
				if (this.status === 'Completed') {
					this.isOverDue = false;
					this.unLockStr = 'Rate this assignment';
				}
				this.unLockStr = data.endDateTime
					? `Due on ${format(new Date(data.endDateTime), 'dd MMMM')}`
					: '';

				if (
					!!data.submissionId &&
					data.submissionDate &&
					data.assignmentStatus === 'Completed'
				) {
					this.unLockStr = 'Rate this assignment';
					this.expandSubStr =
						'Submitted on ' +
						format(new Date(data.submissionDate), 'dd MMM yyyy • hh:mm a');
				} else if (!!data.groupPadId) {
					this.expandSubStr =
						'Unlocked on ' +
						format(new Date(data.startDateTime), 'dd MMM yyyy • hh:mm a');
				} else {
					this.expandSubStr =
						'Due on ' +
						format(new Date(data.endDateTime), 'dd MMM yyyy • hh:mm a');
				}
			}
		}
		// Unlocked on 13 May 2022 • 10:30 PM IST
		// this.expandSubStr =
		// 	'Unlocks on ' +
		// 	format(new Date(data.startDateTime), 'dd MMM yyyy • hh:mm a');

		this.reloadIcon();
	}

	ngOnInit(): void {}

	reloadIcon() {
		if (this.status === 'Locked') {
			this.icon = 'lock-closed-outline';
			this.iconToast = 'Locked 🔒';
		} else {
			if (this.type === 'class') {
				this.icon = 'document-outline';
			} else if (this.type === 'events') {
				this.icon = 'calendar-outline';
			} else if (this.type === 'assignments') {
				this.icon = 'pencil-outline';
			}

			if (this.status === 'Unlocked') {
				this.iconToast = 'Unlocked 🔑';
			} else if (this.status === 'In progress') {
				this.iconToast = 'In progress ⏳';
			} else if (this.status === 'Completed') {
				this.icon = 'checkmark-outline';
				this.iconToast = 'Completed 🎉';
			}
		}
		if (this.type === 'announcement') {
			this.icon = 'time-outline';
			if (this.data.announcementType === 'survey') {
				this.toolTipText = 'Go to link';
			}
			if (this.data.announcementType === 'general') {
				this.toolTipText = 'Copy';
			} else if (this.data.announcementType === 'calendar') {
				this.toolTipText = 'Add to Calendar';
			}
		}
	}

	async openRatingModal(event, type?) {
		let css = type === 'cal' ? 'addCalendar-modal' : 'rating-modal';
		const modal = await this.popoverController.create({
			component: RatingModalComponent,
			cssClass: css,
			componentProps: {
				type,
				eventData: this.data,
				cohortId: this.data.cohortId,
			},
			event,
		});
		if (type === 'cal') {
			modal.style.cssText = `--offset-x: 300px;`;
		}
		return await modal.present();
	}
	onDismiss(event, id?) {
		event.stopPropagation();
		this.learningService.deleteAnnouncementApi(id).subscribe((data: any) => {
			if (data.message) {
				this.learningService.editState(
					'events',
					this.data.cohortId,
					this.data.eventId,
					'eventId',
					'dismissed',
					true,
				);
			}
		});
		this.rudderStack.log({
			type: 'announcement_dismiss',
			announcementText: this.data.name,
		});
		// delete the announcement from backend
	}
	onRateEvent(event) {
		if (this.status === 'Completed') {
			event.stopPropagation();
			this.openRatingModal(event, 'rating');
		}
		return;
	}
	expand(event) {
		if (this.type === 'announcement') {
			if (this.data.announcementType === 'survey') {
				window.open(this.data.announcementAction, '_blank');
			}
			if (this.data.announcementType === 'referral') {
				navigator.clipboard.writeText(this.data.announcementAction);
			} else if (this.data.announcementType === 'calendar') {
				this.openRatingModal(event, 'cal');
			} else {
				window.open(this.data.announcementAction, '_blank');
			}
			this.rudderStack.log({
				type: 'announcement_click',
				announcementText: this.data.name,
				cohortId: this.data.cohortId,
			});
			return;
		}
		this.optionCard = !this.optionCard;
		this.arrowIconName = this.optionCard
			? 'chevron-up-outline'
			: 'chevron-down-outline';
		console.log(this.data);
		if (this.optionCard === true) {
			if (this.type === 'class') {
				this.rudderStack.log({
					type: 'class_open_card',
					cohortId: this.data.cohortId,
					classId: this.data.classId,
				});
			}
			else if (this.type === 'assignments') {
				this.rudderStack.log({
					type: 'assignment_open_card',
					cohortId: this.data.cohortId,
					assignmentId: this.data.classId,
					name: this.data.name
				});
			}
			else if(this.type === 'events'){
				this.rudderStack.log({
					type: 'event_open_card',
					cohortId: this.data.cohortId,
					eventId: this.data.eventId,
					name: this.data.name 
				});
			}
		}
	}

	openWindow(url) {
		if (url) {
			window.open(url, '_blank');
		}
	}
}
